module.exports = __webpack_public_path__ + "static/img/section-intro.1f8c262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/course-detail/section-intro.png
// module id = LRgh
// module chunks = 1